var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * ArrowTriangularLeft component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconArrowTriangularLeft extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon cat-c-icon-bi-directional', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16.1727 4.57144C16.1727 4.34032 16.0335 4.13196 15.82 4.04351C15.6064 3.95507 15.3606 4.00396 15.1972 4.16738L8.17394 11.1907C8.06595 11.2939 7.9797 11.4178 7.92031 11.555C7.8595 11.6955 7.82812 11.8469 7.82812 12C7.82812 12.1531 7.8595 12.3045 7.92031 12.445C7.9797 12.5822 8.06595 12.706 8.17394 12.8093L15.1972 19.8326C15.3606 19.9961 15.6064 20.0449 15.82 19.9565C16.0335 19.8681 16.1727 19.6596 16.1727 19.4285V4.57144Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconArrowTriangularLeft.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconArrowTriangularLeft.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconArrowTriangularLeft.prototype, "size", void 0);
if (customElements.get('cat-icon-arrow-triangular-left') === undefined) {
    customElements.define('cat-icon-arrow-triangular-left', BlocksIconArrowTriangularLeft);
}
